document.addEventListener ('DOMContentLoaded', function () {
  tabMenuSetting (); // タブの設定
});

/**
 * タブの設定（試合成績、ニュース、写真集、選手名鑑等）
 */
function tabMenuSetting () {
  const tabs = document.querySelectorAll ('#tournament-tab-menu li');
  const contents = document.querySelectorAll ('.common-tab-contents');

  tabs.forEach (tab => {
    tab.addEventListener ('click', function () {
      tabs.forEach (t => t.classList.remove ('current'));
      this.classList.add ('current');

      const targetId = this.getAttribute ('data-target');
      contents.forEach (content => {
        if (content.id === targetId) {
          content.style.display = 'block';
          content.classList.add ('current');
        } else {
          content.style.display = 'none';
          content.classList.remove ('current');
        }
      });
    });
  });
}